import { render, staticRenderFns } from "./Personal.vue?vue&type=template&id=e8a0f54e&scoped=true"
import script from "./Personal.vue?vue&type=script&lang=js"
export * from "./Personal.vue?vue&type=script&lang=js"
import style0 from "./Personal.vue?vue&type=style&index=0&id=e8a0f54e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a0f54e",
  null
  
)

export default component.exports